import AzureFunctionCall from "./AzureFunctionsCall";
import CommunityCourseItem from "./models/CommunityCourseItem";

export default class CourseConfigApi {

    private functionCall: AzureFunctionCall = new AzureFunctionCall();

    async load(): Promise<CommunityCourseItem[]> {
        const result = await this.functionCall.Get('managecourseconfig');
        if (!result.ok) {
            throw new Error('Failed to load course configuration');
        }
        return await result.json();
    }

    async save(items: CommunityCourseItem[]): Promise<void> {
        const result = await this.functionCall.Put('managecourseconfig', items);
        if (!result.ok) {
            throw new Error('Failed to save course configuration');
        }
    }
}
